import { useNotifications } from "@/stores/NotificationsContext";
import { useQueryClient } from "@tanstack/react-query";
import { Bell } from "lucide-react";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export const NotificationsBell: React.FC = () => {
  const { notifications, isLoading, error } = useNotifications();
  const queryClient = useQueryClient();

  // Count unread notifications
  const unreadCount = notifications.filter((n) => !n.is_read).length;

  // Set up polling for new notifications every 30 seconds
  useEffect(() => {
    // Don't set up polling if there was an error
    if (error) return;

    const pollingInterval = setInterval(() => {
      // Use the queryClient to refetch the notifications
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    }, 30000); // 30 seconds

    return () => {
      clearInterval(pollingInterval);
    };
  }, [error, queryClient]);

  return (
    <div className="flex items-center">
      <Link to="/notifications" className="ml-3">
        <div className="relative flex items-center gap-1.5 px-3 py-[0.3rem] h-[34px] rounded-md bg-gray-700 hover:bg-gray-600 border border-gray-600 text-gray-200 text-sm transition-all duration-200">
          <Bell size={16} className="text-gray-300" />
          {!isLoading && unreadCount > 0 && (
            <span className="flex items-center justify-center min-w-[18px] h-[18px] rounded-full bg-indigo-500 text-white text-xs font-medium">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          )}
        </div>
      </Link>
    </div>
  );
};
